
import PropTypes from 'prop-types';

import ReactPlayer from 'react-player';

import { LazyLoadComponent } from 'react-lazy-load-image-component';

import useResponsive from '../../../utils/responsive';

const VideoSection = (props) => {
    
    const { videoUrl } = props;
    const { isMobile } = useResponsive();

    if (!videoUrl) {
        return (
            <div className='video-section-empty-space' />
        );
    }

    return (
        <div className='video-section-video-div-home'>
            <div className="container-root container-root-maxWidthLg section-home-oclub-form">
                <div className='video-section-video-container'>
                    <LazyLoadComponent>
                        <ReactPlayer
                            className="react-player"
                            url={videoUrl}
                            playing={false}
                            width="100%"
                            height={isMobile ? 180 : 740}
                            controls
                        />
                    </LazyLoadComponent>
                </div>
            </div>
        </div>
    );
};

export default VideoSection;

VideoSection.propTypes = {
    title: PropTypes.string,
    subHeading: PropTypes.string,
    videoUrl: PropTypes.string,
    isHome: PropTypes.bool,
    isPartners: PropTypes.bool,
    marginTop: PropTypes.number,
    marginBottom: PropTypes.number,
    marginTopMobile: PropTypes.number,
    marginBottomMobile: PropTypes.number,
};

